import React, { useEffect, useState } from "react";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import NumbersIcon from "@mui/icons-material/Numbers";
import WorkIcon from "@mui/icons-material/Work";
import HomeIcon from "@mui/icons-material/Home";
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  getRequestInfo_PrevCheck,
  sendDeliveryRequest,
  sendUserNotification,
} from "../../utilities";
import { selectUser } from "../../features/userSlice";
import { useSelector } from "react-redux";
import { Banner, inputCls } from "./wdUi";

const RequestDeliveryModal = (props) => {
  const [checked, setChecked] = useState(true);
  const [prevSubmit, setPrevSubmit] = useState(true);
  const [startDate, setStartDate] = useState(new Date());
  const user = useSelector(selectUser);
  const [notes, setNotes] = useState("");

  const handleChange = () => {
    setChecked(!checked);
  };

  function closeModal() {
    props.setIsOpen(false);
  }

  const requestDelivery = (orderID, customer, job, SalesOrderNumber) => {
    sendUserNotification(
      "amanda.abeyta@bigclumber.com",
      "System",
      `${user.name} has requested a delivery for ${customer} | ${job} | ${SalesOrderNumber}`,
      "New Delivery Request",
      "/windowdoor/admin/requestlist"
    );
    sendUserNotification(
      "blake.upham@bigclumber.com",
      "System",
      `${user.name} has requested a delivery for ${customer} | ${job} | ${SalesOrderNumber}`,
      "New Delivery Request",
      "/windowdoor/admin/requestlist"
    );
    sendUserNotification(
      "nathan.bilancio@bigclumber.com",
      "System",
      `${user.name} has requested a delivery for ${customer} | ${job} | ${SalesOrderNumber}`,
      "New Delivery Request",
      "/windowdoor/admin/requestlist"
    );
    sendDeliveryRequest(
      orderID,
      customer,
      job,
      SalesOrderNumber,
      notes,
      startDate,
      user.name,
      user.email,
      checked
    );
  };

  useEffect(() => {
    getRequestInfo_PrevCheck(props.orderID, setPrevSubmit);
  }, []);

  const infoFields = [
    {
      key: "customer",
      icon: <PersonOutlineIcon sx={{ fontSize: 16 }} />,
      label: "Customer",
      value: props.selectedRowData.Customer,
    },
    {
      key: "order",
      icon: <NumbersIcon sx={{ fontSize: 16 }} />,
      label: "Order Number",
      value: props.selectedRowData["SO #"],
    },
    {
      key: "job",
      icon: <WorkIcon sx={{ fontSize: 16 }} />,
      label: "Job Ref",
      value: props.selectedRowData.Job,
    },
    {
      key: "deliver",
      icon: <HomeIcon sx={{ fontSize: 16 }} />,
      label: "Deliver To Address",
      value: props.selectedRowData["Deliver To"],
      wide: true,
    },
  ];

  return (
    <>
      <DialogTitle>Request Delivery</DialogTitle>
      <DialogContent dividers>
        <div className="space-y-5">
          <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
            {infoFields.map((field) => (
              <div
                key={field.key}
                className={`app-surface rounded-xl border px-3 py-2.5 ${
                  field.wide ? "sm:col-span-3" : ""
                }`}
              >
                <p className="app-muted flex items-center gap-1.5 text-xs font-medium">
                  {field.icon}
                  {field.label}
                </p>
                <p className="mt-0.5 break-words text-sm font-semibold">
                  {field.value || "—"}
                </p>
              </div>
            ))}
          </div>

          <div className="app-surface space-y-3 rounded-xl border p-4">
            <label className="flex cursor-pointer items-center gap-3">
              <input
                className="h-4 w-4 accent-sky-600"
                type="checkbox"
                checked={checked}
                onChange={handleChange}
              />
              <span className="text-sm font-semibold">
                Earliest Available Date?
              </span>
            </label>
            {!checked && (
              <div className="flex flex-wrap items-center gap-3 border-t app-divider pt-3">
                <p className="text-sm font-semibold">Select Delivery Date:</p>
                <DatePicker
                  selected={startDate}
                  minDate={new Date()}
                  onChange={(date) => setStartDate(date)}
                  className={`${inputCls} !w-44`}
                />
              </div>
            )}
          </div>

          <div>
            <label
              htmlFor="delivery-request-notes"
              className="mb-1.5 block text-sm font-semibold"
            >
              Notes
            </label>
            <textarea
              id="delivery-request-notes"
              name="notes"
              rows="3"
              className={inputCls}
              placeholder="enter optional notes"
              onChange={(e) => {
                setNotes(e.target.value);
              }}
              value={notes}
            ></textarea>
          </div>

          {prevSubmit && (
            <Banner tone="warning">
              You have already requested a delivery of this order, please
              contact Window Door for further assistance!
            </Banner>
          )}
        </div>
      </DialogContent>
      <DialogActions>
        {!prevSubmit ? (
          <>
            <Button
              color="inherit"
              onClick={() => {
                closeModal();
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="success"
              onClick={() => {
                closeModal();
                props.setOpen(true);
                requestDelivery(
                  props.orderID,
                  props.customer,
                  props.job,
                  props.SalesOrderNumber
                );
              }}
            >
              Request Delivery
            </Button>
          </>
        ) : (
          <Button
            variant="outlined"
            onClick={() => {
              closeModal();
              setPrevSubmit(false);
            }}
          >
            Close
          </Button>
        )}
      </DialogActions>
    </>
  );
};

export default RequestDeliveryModal;
